var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelcomeR(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 222,
    viewBox: "0 0 96 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58578 87.0403C4.56223 86.7492 4.79212 86.5 5.08415 86.5H90.9159C91.2079 86.5 91.4378 86.7492 91.4142 87.0403L80.576 221.04C80.555 221.3 80.3381 221.5 80.0776 221.5H70H48H26H15.9224C15.6619 221.5 15.445 221.3 15.424 221.04L4.58578 87.0403Z",
    fill: "white",
    stroke: "#2A2B3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08633 125.08C5.03981 124.498 5.49944 124 6.08315 124H89.9156C90.4998 124 90.9596 124.499 90.9124 125.081L86.5745 178.581C86.5324 179.1 86.0987 179.5 85.5778 179.5H10.3607C9.83935 179.5 9.40547 179.099 9.36392 178.58L5.08633 125.08Z",
    fill: "url(#paint0_linear_1527_4269)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 82C0.5 79.5147 2.51472 77.5 5 77.5H91C93.4853 77.5 95.5 79.5147 95.5 82V86C95.5 86.2761 95.2761 86.5 95 86.5H1C0.723858 86.5 0.5 86.2761 0.5 86V82Z",
    fill: "white",
    stroke: "#2A2B3A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 73C6.5 70.5147 8.51472 68.5 11 68.5H85C87.4853 68.5 89.5 70.5147 89.5 73V77C89.5 77.2761 89.2761 77.5 89 77.5H7C6.72386 77.5 6.5 77.2761 6.5 77V73Z",
    fill: "white",
    stroke: "#2A2B3A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2464 63.8419C27.3145 63.6377 27.5055 63.5 27.7208 63.5H38.2792C38.4945 63.5 38.6855 63.6377 38.7536 63.8419L40.0869 67.8419C40.1948 68.1657 39.9539 68.5 39.6126 68.5H26.3874C26.0461 68.5 25.8052 68.1657 25.9131 67.8419L27.2464 63.8419Z",
    fill: "white",
    stroke: "#2A2B3A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.092 1C31.7587 5.5 35.692 17.6 30.092 30C24.492 42.4 27.7587 53.5 30.092 57.5",
    stroke: "#2A2B3A",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.092 1C36.7587 5.5 40.692 17.6 35.092 30C29.492 42.4 32.7587 53.5 35.092 57.5",
    stroke: "#2A2B3A",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1527_4269",
    x1: 5,
    y1: 152,
    x2: 76.4052,
    y2: 184.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA5455"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeR);
export default __webpack_public_path__ + "static/media/welcome-r.221e671442d8eeff5b6817af0037d5a4.svg";
export { ForwardRef as ReactComponent };